import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { selectAdvancedFilters } from '@app/modules/core/reducers/filter.reducer';
import * as ProductActions from '@core/actions/product.actions';
import * as fromProduct from '@core/reducers/product.reducer';
import { select, Store } from '@ngrx/store';
import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';
import * as ProductShipmentActions from '@core/actions/product-shipment.actions';

@Component({
  selector: 'app-advanced-filters-area',
  templateUrl: './advanced-filters-area.component.html',
  styleUrls: ['./advanced-filters-area.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedFiltersAreaComponent implements OnInit {
  @Input()
  advancedFilters;

  @Input()
  selectedFilter;

  @Input()
  selectProforma;

  @Input()
  followId;

  @Output()
  removeFilter = new EventEmitter();

  filter$ = this.store.pipe(select(fromProduct.getFilters));

  constructor(private store: Store<any>) {}

  ngOnInit() {}

  deleteFil(filter) {
    //this.store.dispatch(
    //new ProductActions.LoadByFollow(this.followId, { type: 'minimal' })
    //);
    this.store.dispatch(new ProductActions.SearchClear());
    this.store.dispatch(new ProductActions.FilterClear(filter));

    //this.removeFilter.emit();
  }

  cancelWeightedFob() {
    this.store.dispatch(
      new ProformaActionTypes.UpdateCancel(this.selectProforma.id, {
        amountType: null,
        amount: 0,
        FollowId: this.selectProforma.FollowId,
        proformaId: this.selectProforma.id
      })
    );

    // await this.store.dispatch(
    //   new ProductShipmentActions.LoadByFollow(
    //     this.selectProforma.FollowId,
    //     null,
    //     this.selectProforma.id
    //   )
    // );
  }

  amountType(type) {
    if (type === 'discount') {
      return 'Descuento';
    } else {
      return 'Costo extra';
    }
  }
}
